"use client";

import { useConfiguration } from "@/hooks/useConfiguration";
import { useLocale } from "@cloudspire/shared/contexts/Locale";
import useRequest from "@cloudspire/shared/hooks/useRequest";
import { useRouters } from "@cloudspire/shared/hooks/useRouters";
import { useEffect, useState } from "react";

export function IntlMessagesUpdater() {
  const { locale, setMessages } = useLocale();

  const [loadedLocale, setLoadedLocale] = useState(locale);

  const { request } = useRequest();

  const { configuration } = useConfiguration();

  const { accountRouter } = useRouters();

  useEffect(() => {
    if (locale !== loadedLocale) {
      request(
        accountRouter.getUrl({
          id: "@account-v2/api.translations",
          overrides: {
            query: [["locale", locale]],
          },
        }),
      ).then((response) => {
        setMessages(response.parsedJson);
        setLoadedLocale(locale);
      });
    }
  }, [
    accountRouter,
    configuration?.domain,
    configuration?.subdomains.account,
    loadedLocale,
    locale,
    request,
    setMessages,
  ]);

  return null;
}
